module.exports = __webpack_public_path__ + "static/media/ic-vistalabs-logo.98205ae2.svg";